import gql from 'graphql-tag';

export default gql`
  mutation removeUserIntegration($channelIntegrationId: UUID!) {
    removeUserIntegration(channelIntegrationId: $channelIntegrationId)
  }
`;
